export const MB_TO_BYTE_MULTIPLIER = 1024 * 1024;

export const THUMBNAILS_MODE_PARAM = 'thumbnails_mode';

export const CLOUDINARY_SUPPORTED_IMAGE_EXTENSIONS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'webp',
    'bmp',
    'tiff',
    'tif',
    'ico',
    'pdf',
    'svg',
    'psd',
    'ai',
    'eps',
    'heif',
    'heic'
];

export const AcceptedFileFormats = {
    AllImages: ['image/*'],
    CloudinarySupported: CLOUDINARY_SUPPORTED_IMAGE_EXTENSIONS
};
